import React from 'react';
import Helmet from 'react-helmet';

const ScriptTags = () => {  
    return (
        <span style={{display: 'none'}}>
            <Helmet>
                <script async src="https://www.googletagmanager.com/gtag/js?id=AW-1040796449"></script>
                <script type="text/javascript" src="https://services.xg4ken.com/js/kenshoo.js?cid=af9a1df0-aa7a-45a6-aed0-
                    4fbc1437b7df" ></script>
                <script src="https://js.adsrvr.org/up_loader.1.1.0.js" type="text/javascript"></script>
            </Helmet>
            <Helmet 
              script={[
                {
                type: 'text/javascript',
                innerHTML: `
                    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

                    ga('create', 'UA-1652012-1', 'none');
                
                    
                    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
                        document,'script','https://connect.facebook.net/en_US/fbevents.js');

                        fbq('init', '508583122629466');

                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'AW-1040796449');
                    gtag('config', 'DC-6346097');
                    
                    ttd_dom_ready( function() {
                        if (typeof TTDUniversalPixelApi === 'function') {
                            var universalPixelApi = new TTDUniversalPixelApi();
                            universalPixelApi.init("af2kihf", ["gw0dtln"], "https://insight.adsrvr.org/track/up");
                        }
                    });
                `
              }
            ]}
            /> 
            <img src="https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=434362&ec=localrtg"/>
            {/* <noscript>
                <img height="1" width="1" src="https://www.facebook.com/tr?id=508583122629466&ev=PageView&noscript=1" />
                <img src="https://ad.doubleclick.net/ddm/activity/src=6346097;type=fall1003;cat=fall10;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
            </noscript> */}
        </span>
    );
};

export default ScriptTags;


// WEBPACK FOOTER //
// ./src/components/ScriptTags.js